import services from 'utils/mockAdapter';
// user list
const Users = [
    {
        id: '10011',
        usercode: 'moti@taleng.com ',
        name: 'Moti Titel',
        manufacturer: 'All',
        dealer: 'All',
        role: 'Admin',
        status: 'Active',
        lastloginat: '15-Jun-2022 13:42'
    },
    {
        id: '10012',
        usercode: 'user1@savaria.com ',
        name: 'User One',
        manufacturer: 'Savaria 2',
        dealer: 'All',
        role: 'Admin',
        status: 'Active',
        lastloginat: '15-Jun-2022 13:42'
    },
    {
        id: '10013',
        usercode: 'user2@savaria.com ',
        name: 'User Two',
        manufacturer: 'Savaria',
        dealer: 'All',
        role: 'User',
        status: 'Active',
        lastloginat: '15-Jun-2022 13:42'
    },
    {
        id: '10011',
        usercode: 'dealer@taleng.com ',
        name: 'Delaer ',
        manufacturer: 'Saveria',
        dealer: 'Delaer One',
        role: 'Admin',
        status: 'Active',
        lastloginat: '15-Jun-2022 13:42'
    },
    {
        id: '10011',
        usercode: 'moti@taleng.com ',
        name: 'Moti Titel',
        manufacturer: 'All',
        dealer: 'All',
        role: 'Admin',
        status: 'Active',
        lastloginat: '15-Jun-2022 13:42'
    },
    {
        id: '10011',
        usercode: 'moti@taleng.com ',
        name: 'Moti Titel',
        manufacturer: 'All',
        dealer: 'All',
        role: 'Admin',
        status: 'Active',
        lastloginat: '15-Jun-2022 13:42'
    },
    {
        id: '10011',
        usercode: 'moti@taleng.com ',
        name: 'Moti Titel',
        manufacturer: 'All',
        dealer: 'All',
        role: 'Admin',
        status: 'Active',
        lastloginat: '15-Jun-2022 13:42'
    },
    {
        id: '10011',
        usercode: 'moti@taleng.com ',
        name: 'Moti Titel',
        manufacturer: 'All',
        dealer: 'All',
        role: 'Admin',
        status: 'Active',
        lastloginat: '15-Jun-2022 13:42'
    },
    {
        id: '10011',
        usercode: 'moti@taleng.com ',
        name: 'Moti Titel',
        manufacturer: 'All',
        dealer: 'All',
        role: 'Admin',
        status: 'Active',
        lastloginat: '15-Jun-2022 13:42'
    },
    {
        id: '10011',
        usercode: 'moti@taleng.com ',
        name: 'Moti Titel',
        manufacturer: 'All',
        dealer: 'All',
        role: 'Admin',
        status: 'Active',
        lastloginat: '15-Jun-2022 13:42'
    },
    {
        id: '10011',
        usercode: 'moti@taleng.com ',
        name: 'Moti Titel',
        manufacturer: 'All',
        dealer: 'All',
        role: 'Admin',
        status: 'Active',
        lastloginat: '15-Jun-2022 13:42'
    },
    {
        id: '10011',
        usercode: 'moti@taleng.com ',
        name: 'Moti Titel',
        manufacturer: 'All',
        dealer: 'All',
        role: 'Admin',
        status: 'Active',
        lastloginat: '15-Jun-2022 13:42'
    },
    {
        id: '10011',
        usercode: 'moti@taleng.com ',
        name: 'Moti Titel',
        manufacturer: 'All',
        dealer: 'All',
        role: 'Admin',
        status: 'Active',
        lastloginat: '15-Jun-2022 13:42'
    }
];
// ==============================|| MOCK SERVICES ||============================== //
services.onGet('/api/manufacturers/users/list').reply(200, { Users });
